import { 
    DashboardOutlined,
    MailOutlined
} from '@ant-design/icons';
import { APP_PREFIX_PATH } from 'configs/AppConfig'
import {getSession, getUserSession} from "../components/util-components/Session/Session";

let dashBoardNavTree = [];

dashBoardNavTree = [
    {
        key: 'E Application',
        path: `${APP_PREFIX_PATH}/application`,
        title: 'E Application',
        icon: DashboardOutlined,
        breadcrumb: false,
        submenu: [
            {
                key: 'App-List',
                path: `${APP_PREFIX_PATH}/application`,
                title: 'List',
                icon: MailOutlined,
                breadcrumb: true,
                submenu: []
            },
            {
                key: 'schedules-list',
                path: `${APP_PREFIX_PATH}/schedules`,
                title: 'Schedules',
                icon: MailOutlined,
                breadcrumb: true,
                submenu: []
            }
        ]
    },{
        key: 'Complains',
        path: `${APP_PREFIX_PATH}/complains`,
        title: 'Complains',
        icon: DashboardOutlined,
        breadcrumb: true,
        submenu: [
            {
                key: 'Complain-List',
                path: `${APP_PREFIX_PATH}/complains`,
                title: 'List',
                icon: MailOutlined,
                breadcrumb: true,
                submenu: []
            }
        ]
    }
]


const navigationUserConfig = [
  ...dashBoardNavTree
]

export default navigationUserConfig;
